module.exports = __webpack_public_path__ + "static/img/btn2.a595844.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn2.png
// module id = fZqu
// module chunks = 1